import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_PARAMETER_REQUEST,
  FETCH_PARAMETER_SUCCESS,
  FETCH_PARAMETER_ERROR,
  UPDATE_PARAMETER_REQUEST,
  UPDATE_PARAMETER_SUCCESS,
  UPDATE_PARAMETER_ERROR,
  GET_PARAMETER_FROM_LIST,
  RESET_PARAMETERS,
  RESET_EDIT_PARAMETER,
  UPDATE_PARAMETER_FILTER,
  GET_PAGES,
  FETCH_CURRENT_BASE_ERROR,
  FETCH_CURRENT_BASE_SUCCESS,
} from 'actionTypes'

const getPages = (metadata = {}) => ({
  type: GET_PAGES,
  pages: metadata.pageCount,
  current: metadata.page,
  count: metadata.totalCount,
})

export const fetchCurrentBase = (token) => (dispatch) =>
  new Api(token, dispatch)
    .post(API_URL.PARAMETER_FIND, {
      dsKey: 'current.base',
      hasPagination: true,
      page: 1,
    })
    .then(dispatch(showSpinner()))
    .then(
      (response) => {
        dispatch({
          type: FETCH_CURRENT_BASE_SUCCESS,
          payload:
            response &&
            response.data &&
            response.data.resultList &&
            response.data.resultList[0] &&
            response.data.resultList[0].dsValue,
        })
      },
      (error) => {
        dispatch({
          type: FETCH_CURRENT_BASE_ERROR,
          payload: error,
        })
      }
    )
    .finally(() => dispatch(hideSpinner()))

/*
 * REQUEST PARAMETER
 */
export const fetchParameters =
  (token, filters, page = 1) =>
  (dispatch) => {
    dispatch(fetchParametersRequest())

    const params = {
      ...filters,
      hasPagination: true,
      page,
      size: filters.size || 10,
    }

    return new Api(token, dispatch)
      .post(API_URL.PARAMETER_FIND, params)
      .then(dispatch(showSpinner()))
      .then(
        (response) => {
          dispatch(getPages(response.data.pages))
          fetchParametersSuccess(response.data.resultList, dispatch, params)
        },
        (error) => {
          fetchParametersError(error, dispatch)
        }
      )
      .finally(() => dispatch(hideSpinner()))
  }

export const fetchParametersRequest = () => ({
  type: FETCH_PARAMETER_REQUEST,
})

export const fetchParametersSuccess = (data, dispatch, params) => {
  dispatch(parametersSuccess(data, params))
}

const parametersSuccess = (data, params) => ({
  type: FETCH_PARAMETER_SUCCESS,
  payload: data,
  filter: params,
})

export const fetchParametersError = (error, dispatch) => {
  dispatch(parametersError(error))
  dispatch(hideSpinner())
}

export const parametersError = (error) => ({
  type: FETCH_PARAMETER_ERROR,
  payload: error,
})

/*
 * SAVE or UPDATE PARAMETER
 */
export const update = (token, values, onSuccess) => (dispatch) => {
  dispatch(updateParameterRequest())

  return new Api(token, dispatch)
    .post(API_URL.PARAMETER_SAVE, values)
    .then(dispatch(showSpinner()))
    .then((response) => {
      dispatch(updateParameterSuccess(response))
      /* istanbul ignore else */
      if (onSuccess) {
        onSuccess()
      }
    })
    .catch((error) => {
      dispatch(updateParameterError(error))
    })
    .finally(() => dispatch(hideSpinner()))
}



export const updateParameterRequest = () => ({
  type: UPDATE_PARAMETER_REQUEST,
})

export const updateParameterSuccess = (data) => ({
  type: UPDATE_PARAMETER_SUCCESS,
  payload: data,
})

export const updateParameterError = (error) => ({
  type: UPDATE_PARAMETER_ERROR,
  payload: error,
})

/*
 * GET PARAMETER FROM LIST
 */
export const getParameter = (index) => (dispatch) => {
  dispatch({
    type: GET_PARAMETER_FROM_LIST,
    index,
  })
}

export const resetParameters = () => ({
  type: RESET_PARAMETERS,
})

export const resetEditParameter = () => ({
  type: RESET_EDIT_PARAMETER,
})

export const updateFilter = (filter) => (dispatch) => {
  dispatch({
    type: UPDATE_PARAMETER_FILTER,
    filter,
  })
}
